import Container from "react-bootstrap/Container";

export const ScheduleAdmin = () => {

    return (
        <Container className={"d-flex justify-content-center bg-light rounded mb-3"}>
            <h3>Schedule and Time Off</h3>
        </Container>
    );
}